import { render, staticRenderFns } from "./crudPersonal.vue?vue&type=template&id=4a7151c6&scoped=true"
import script from "./crudPersonal.vue?vue&type=script&lang=js"
export * from "./crudPersonal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a7151c6",
  null
  
)

export default component.exports